import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const H3 = styled(Typography)({
  fontWeight: 400,
  fontSize: 20,
});

export const H4 = styled(Typography)({
  fontWeight: 600,
  fontSize: 18,
});
